import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatForeignProgramApplicantList,
	formatForeignProgramDetail,
	formatForeignProgramList,
} from './foreign-program.helper';
import { ForeignProgramActions } from './foreign-program.redux';
import {
	IPayloadGetForeignProgramApplicantListRequest,
	IPayloadGetForeignProgramDetailRequest,
	IPayloadGetForeignProgramListRequest,
} from './foreign-program.type';

export function* getForeignProgramList(
	action: PayloadAction<IPayloadGetForeignProgramListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetForeignProgramListResponse> =
			yield API.getForeignProgramList({ searchTypes, ...rest });
		const content = formatForeignProgramList(res?.data?.content);

		yield put(
			ForeignProgramActions.getForeignProgramListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignProgramActions.getForeignProgramListFailure());
	}
}

export function* getForeignProgramDetail(
	action: PayloadAction<IPayloadGetForeignProgramDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetForeignProgramDetailResponse> =
			yield API.getForeignProgramDetail(id);

		const foreignProgramDetail = formatForeignProgramDetail(res.data);

		yield put(
			ForeignProgramActions.getForeignProgramDetailSuccess({
				foreignProgramDetail,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignProgramActions.getForeignProgramDetailFailure());
	}
}

export function* getForeignProgramApplicantList(
	action: PayloadAction<IPayloadGetForeignProgramApplicantListRequest>
) {
	const { callback, id, params } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetForeignProgramApplicantListResponse> =
			yield API.getForeignProgramApplicantList(id, params);
		const content = formatForeignProgramApplicantList(res?.data?.content);

		yield put(
			ForeignProgramActions.getForeignProgramApplicantListSuccess({
				...params,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(ForeignProgramActions.getForeignProgramApplicantListFailure());
	}
}
